import React from 'react';
const highlights = ['THE productive milling solution', 'Rigid design — Seven models from X 630 till X 1,650mm', 'Y-Stroke 450 to 800 mm'];
const mechanicalEngineering = ['THE productive turning solution for bar machining', 'Most rigid linear roller guideways', 'High rapid speeds', 'Full casting design for dynamic and rigid machining', 'Available as fixed column design (VC-Series)', 'Or moving column versions (U-Series)'];
export function SpecsSection() {
  return <div className="grid md:grid-cols-2 gap-12 mb-20" data-id="element-3788">
      <div data-id="element-3789">
        <h2 className="text-2xl font-bold text-navy mb-6" data-id="element-3790">Highlights</h2>
        <ul className="space-y-3" data-id="element-3791">
          {highlights.map((item, index) => <li key={index} className="flex items-start" data-id="element-3792">
              <span className="text-[#0077B6] mr-3 mt-1.5 text-xl leading-none" data-id="element-3793">
                •
              </span>
              <span className="text-gray-700 text-lg leading-relaxed" data-id="element-3794">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
      <div data-id="element-3795">
        <h2 className="text-2xl font-bold text-navy mb-6" data-id="element-3796">
          Mechanical Engineering
        </h2>
        <ul className="space-y-3" data-id="element-3797">
          {mechanicalEngineering.map((item, index) => <li key={index} className="flex items-start" data-id="element-3798">
              <span className="text-[#0077B6] mr-3 mt-1.5 text-xl leading-none" data-id="element-3799">
                •
              </span>
              <span className="text-gray-700 text-lg leading-relaxed" data-id="element-3800">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
    </div>;
}